export default __webpack_public_path__ + "static/media/money-back.1cebc089.png";